<template>
    <modal @close="closeModal" dialog="modal-m">
        <div slot="title">
            <h2>Credit Note Reason</h2>
        </div>
        <div slot="body">
            <div class="p-4 min-height">
                <v-select
                    :options="getChargeBackReason"
                    :disabled="getIsChargeBackReasonsLoading"
                    label="label"
                    placeholder="Select reason"
                    v-model="selectedReason">
                </v-select>
            
                <div v-if="$v.selectedReason.$invalid" class="mt-1 messages error">
                    <span v-if="!$v.selectedReason.required">Reason is required</span>
                </div>
            </div>
        </div>

        <div slot="footer" class="p-0">
            <div class="d-flex justify-content-end pb-3 pr-4">
                <button type="button" class="btn cancel wider mr-3" @click="closeModal">Cancel</button>
                <button type="button" class="btn ok wider" :class="{'disabled notAllowed': !selectedReason}" @click="confirmClick">
                    <span v-if="!getIsChargeBackReasonsLoading">Confirm</span>
                    <div v-else>
                        <loader size="small"></loader>
                    </div>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Modal from './Modal';
    import extendedVSelect from '@/extends/vue-select';
    import Loader from '@/tools/loaders/loader1';
    import { required } from "vuelidate/lib/validators";

    export default {
        data: function() {
            return {
                selectedReason: null,
            }
        },
        validations: {
            selectedReason: {
                required
            }
        },
        created: function() {
            if (this.getChargeBackReason.length === 0) this.requestChargeBackReason();
        },
        computed: {
            ...mapGetters([
                'getChargeBackReason',
                'getIsChargeBackReasonsLoading'
            ]),
        },
        methods: {
            ...mapActions([
                'closeModal',
                'requestChargeBackReason',
            ]),
            confirmClick: function () {
                this.eventHub.$emit('closeInvoiceCreditNoteReason', this.selectedReason.id);
                this.closeModal();
            },
            closeWindow: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            Loader,
            vSelect: extendedVSelect,
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/_utility.scss";

    .min-height {
        min-height: 110px;
    }
</style>

<style lang="scss">
    .modal .modal-m .modal-footer {
        padding: 0px;
    };

    .modal .modal-m .modal-header {
        padding-bottom: 0px;
    };
</style>



// WEBPACK FOOTER //
// InvoiceCancellation.vue?17cdb1f3